<template>
  <div class="home">
    <div>
      <Header class="w-full" />
    </div>

    <section v-intersect class="section bg-emma">
      <Accueil />
    </section>

    <section v-intersect class="section">
      <About />
    </section>

    <section v-intersect class="section">
      <Pojet />
    </section>

    <section id="contact" class="relative py-12  bg-emma flex flex-wrap flex-col  justify-center ">
      <Title title="Contact" />
     
      
     <div class="flex flex-col items-center justify-center mt-">
       <p>
      Mail : <a href="mailto:emma.nabyt07@gmail.com" class="underline">emma.nabyt07@gmail.com</a>
     </p>
     <p>
    Tel : <a href="tel:+33652047360" class="">06 52 04 73 60</a>
</p>

     
     </div>
     <div class="flex  justify-center items-center">
      <p>linkedin :
       <a class="underline" href="https://www.linkedin.com/in/emma-nabyt-5587a1283/" _Blank> Emma Nabyt</a> </p>
     </div>
    
   
     
   </section>
  </div>
</template>

<script>
import About from '@/components/about.vue';
import Header from '@/components/header.vue';
import Accueil from '@/components/home.vue';
import Pojet from '@/components/projet.vue';
import Parcours from '@/components/parcours.vue';
import Footer from '@/components/footer.vue';
import Title from '@/components/title.vue';

export default {
  name: 'Home',
  components: {
    About,
    Header,
    Accueil,
    Pojet,
    Parcours,
    Footer,
    Title
  },
  directives: {
    intersect: {
      mounted(el) {
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              el.classList.add("visible");
              observer.unobserve(el); // Désactive l'observation après l'apparition
            }
          },
          { threshold: 0.2 }
        );
        observer.observe(el);
      }
    }
  }
};
</script>

<style>
.section {
  opacity: 0;
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
  max-width: 100%; /* Assure que la section ne dépasse pas */
  overflow: hidden;
  width: 100%; /* Ajuste selon la mise en page souhaitée */
}

.section.visible {
  opacity: 1;
  transform: translateX(0); /* Arrête le mouvement au centre */
}


</style>